export default {
  namespaced: true,
  state: {
    isRequestPage: false
  },

  mutations: {
    onClickRequestPage(state, value) {
      state.isRequestPage = value
    },
  },

  getters: {
    clickRequestPage: state => {
      return (state.isRequestPage) ? true : false
    },
  }
}